import { render, staticRenderFns } from "./product-fraction.vue?vue&type=template&id=f5adb6d6&"
import script from "./product-fraction.vue?vue&type=script&lang=js&"
export * from "./product-fraction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports